import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PaymentResult } from '@/types/dtos/transactions/response/payment-result.dto';
import { GET_ORGANIZATION_QUERY_KEY } from '@/state/queries/organizations/use-get-organization.ts';
import { invalidateAllQuotaBalances } from '@/state/queries/entitlements/use-quota-balances';

export type RequestSubscriptionQuotaAddonPayload = {
  organizationId: string;
  quotaKey: string;
  quantity: number;
  redirectUrlAfterPayment: string;
};

export function useRequestSubscriptionQuotaAddon() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RequestSubscriptionQuotaAddonPayload) => {
      const token = await getToken();
      const { organizationId, ...body } = payload;
      const url = `${import.meta.env.VITE_API_URL}/transactions/organization/${organizationId}/subscription-quota-addon`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body,
        token: token ?? '',
      }) as Promise<PaymentResult>;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: [GET_ORGANIZATION_QUERY_KEY, variables.organizationId] });
      await invalidateAllQuotaBalances(queryClient);
    },
  });
}
